import { Badge } from '@/components/ui';
import type { CellRendererProps } from './index';

export function BadgeCell({ value, config }: CellRendererProps) {
  if (value == null || value === '') return null;

  const strValue = String(value);
  const labelMap = config?.labelMap as Record<string, string> | undefined;
  const colorMap = config?.colorMap as Record<string, string> | undefined;
  const variantMap = config?.variantMap as Record<string, string> | undefined;

  const label = labelMap?.[strValue] ?? strValue;
  const className = colorMap?.[strValue];
  const variant = (variantMap?.[strValue] ?? 'default') as 'default' | 'secondary' | 'destructive' | 'outline' | 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'purple' | 'orange';

  return (
    <Badge variant={variant} className={className}>
      {label}
    </Badge>
  );
}
